'use client';
import { FontWeightToStyles } from '../../util/font.js';

var ButtonWidth;
(function (ButtonWidth) {
    ButtonWidth["FULL"] = "FULL";
    ButtonWidth["AUTO"] = "AUTO";
    ButtonWidth["FULL_MOBILE"] = "FULL_MOBILE";
})(ButtonWidth || (ButtonWidth = {}));
var ButtonColor;
(function (ButtonColor) {
    ButtonColor["PRIMARY"] = "PRIMARY";
    ButtonColor["WHITE"] = "WHITE";
    ButtonColor["GRAY"] = "GRAY";
    ButtonColor["RED"] = "RED";
    ButtonColor["PURPLE"] = "PURPLE";
    ButtonColor["LIGHT_BLUE"] = "LIGHT_BLUE";
    ButtonColor["BLUE"] = "BLUE";
    ButtonColor["ORANGE"] = "ORANGE";
    ButtonColor["BLACK"] = "BLACK";
    ButtonColor["TRANSPARENT"] = "TRANSPARENT";
    ButtonColor["REVEAL"] = "REVEAL";
    ButtonColor["LIGHT_RED"] = "LIGHT_RED";
})(ButtonColor || (ButtonColor = {}));
var ButtonSize;
(function (ButtonSize) {
    ButtonSize["SMALL"] = "SMALL";
    ButtonSize["MEDIUM"] = "MEDIUM";
    ButtonSize["LARGE"] = "LARGE";
})(ButtonSize || (ButtonSize = {}));
const ButtonColorToStyles = {
    [ButtonColor.PRIMARY]: (selected) => selected
        ? 'text-leland-primary bg-white border-leland-primary shadow-leland-primary'
        : 'text-white bg-leland-primary border-leland-primary disabled:bg-leland-primary hover:bg-leland-primary-hover hover:border-leland-primary-hover shadow-transparent',
    [ButtonColor.WHITE]: (selected) => selected
        ? 'text-leland-gray-dark bg-white border-leland-gray-dark shadow-leland-gray-dark'
        : // border should NOT update on hover
            'text-leland-gray-dark bg-white disabled:bg-white border-leland-gray-stroke hover:bg-leland-gray-hover shadow-transparent',
    [ButtonColor.GRAY]: (selected) => selected
        ? 'text-leland-gray-dark bg-white border-leland-gray-dark shadow-leland-gray-dark'
        : 'text-leland-gray-light bg-leland-gray-hover disabled:bg-leland-gray-hover border-leland-gray-hover hover:bg-leland-gray-stroke hover:border-leland-gray-stroke shadow-transparent',
    [ButtonColor.RED]: (selected) => selected
        ? 'text-leland-red bg-white border-leland-red shadow-leland-red'
        : 'text-white bg-leland-red disabled:bg-leland-red border-leland-red hover:bg-leland-red-hover hover:border-leland-red-hover shadow-transparent',
    [ButtonColor.PURPLE]: (selected) => selected
        ? 'text-leland-purple bg-white border-leland-purple shadow-leland-purple'
        : 'text-white bg-leland-purple disabled:bg-leland-purple border-leland-purple hover:bg-leland-purple-hover hover:border-leland-purple-hover shadow-transparent',
    [ButtonColor.LIGHT_BLUE]: (selected) => selected
        ? 'text-leland-blue bg-white border-leland-blue shadow-leland-blue'
        : 'text-leland-blue bg-leland-blue-light disabled:bg-leland-blue-light border-leland-blue-light hover:bg-leland-blue-light-hover hover:border-leland-blue-light-hover shadow-transparent',
    [ButtonColor.BLUE]: (selected) => selected
        ? 'text-leland-blue bg-white border-leland-blue shadow-leland-blue'
        : 'text-leland-white bg-leland-blue disabled:bg-leland-blue border-leland-blue hover:bg-leland-blue-hover hover:border-leland-blue-hover shadow-transparent',
    [ButtonColor.ORANGE]: (selected) => selected
        ? 'text-leland-orange bg-white border-leland-orange shadow-leland-orange'
        : 'text-leland-white bg-leland-orange disabled:bg-leland-orange border-leland-orange hover:bg-leland-orange-dark hover:border-leland-orange-dark shadow-transparent',
    [ButtonColor.BLACK]: (selected) => selected
        ? 'text-leland-black bg-white border-leland-black shadow-leland-black'
        : 'text-white bg-leland-black disabled:bg-leland-black border-leland-black hover:bg-leland-gray-dark hover:border-leland-gray-dark shadow-transparent',
    [ButtonColor.TRANSPARENT]: (selected) => selected
        ? 'text-leland-white bg-transparent border-leland-white shadow-leland-white'
        : // border should NOT update on hover
            'text-leland-white bg-transparent disabled:bg-transparent border-leland-white hover:bg-leland-white/5 shadow-transparent',
    [ButtonColor.REVEAL]: (selected) => selected
        ? 'text-leland-gray-dark bg-transparent border-transparent shadow-transparent'
        : 'text-leland-gray-dark bg-transparent disabled:text-leland-gray-light disabled:bg-transparent hover:bg-leland-gray-hover border-transparent shadow-transparent',
    [ButtonColor.LIGHT_RED]: (selected) => selected
        ? 'text-leland-red bg-leland-red-light border-transparent shadow-transparent'
        : 'text-leland-red bg-leland-red-light disabled:text-leland-gray-light disabled:bg-transparent hover:bg-leland-red-light-hover border-transparent shadow-transparent',
};
const ButtonSizeToStyles = {
    [ButtonSize.SMALL]: 'p-2 text-sm leading-none space-x-1',
    [ButtonSize.MEDIUM]: 'p-3 text-base space-x-2',
    [ButtonSize.LARGE]: 'py-4 px-5 text-base space-x-2',
};
const ButtonSizeToIconStyles = {
    [ButtonSize.SMALL]: 'size-3.5',
    [ButtonSize.MEDIUM]: 'size-5',
    [ButtonSize.LARGE]: 'size-5',
};
const ButtonWidthToStyles = {
    [ButtonWidth.FULL]: 'flex w-full',
    [ButtonWidth.AUTO]: 'inline-flex',
    [ButtonWidth.FULL_MOBILE]: 'flex w-full sm:w-auto sm:inline-flex',
};
const getButtonStyles = ({ buttonColor, size, width, fontWeight, rounded, selected, }) => `sm:whitespace-nowrap leading-tight items-center justify-center border shadow-border ${ButtonColorToStyles[buttonColor](selected)} ${ButtonSizeToStyles[size]} ${ButtonWidthToStyles[width]} ${FontWeightToStyles[fontWeight]} ${rounded ? 'rounded-full' : 'rounded-lg'}`;

export { ButtonColor, ButtonSize, ButtonSizeToIconStyles, ButtonWidth, getButtonStyles };
//# sourceMappingURL=constants.js.map
